import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  clearFetchedData,
  updateCurrentPeriodId,
  updateDate,
  updateLastPeriodId,
  updateLatestAcceptedPeriodId,
  updateOpenPeriodId,
} from '/redux/action/testingOptions.action';
import {
  currentPeriodId,
  lastPeriodId,
  latestAcceptedPeriodId,
  openPeriodId,
  testingDate,
} from '/redux/selector/testingOptions.selector';

import {TestingOptions} from './TestingOptions';

export const TestingOptionsConnected = connect(
  createStructuredSelector({
    initialPeriodId: currentPeriodId,
    initialLastPeriodId: lastPeriodId,
    initialLatestAcceptedPeriodId: latestAcceptedPeriodId,
    initialOpenPeriodId: openPeriodId,
    initialDate: testingDate,
  }),
  {
    updateCurrentPeriodId,
    updateDate,
    updateLastPeriodId,
    updateLatestAcceptedPeriodId,
    updateOpenPeriodId,
    clearFetchedData,
  },
)(TestingOptions);
